import axios from 'axios';
import Cookies from "js-cookie";

import { charsheetAPI, TABLE_USERS } from '../globals.js';

import createUser from './createUser.js'

const addCampaignToUser = async ( campaignName, userData ) => {
            const userTable = TABLE_USERS
            // const campaignName = 'js-test-campaign'
            const queryAPI = charsheetAPI + '?TableName=' + userTable + '&UserName=' + userData.uniqueUser
            let userDataDynamo = userData.dynamoData;
            const campaignList = userDataDynamo.campaigns;
            // add campaign to userData.dynamoData.campaigns
            // check if campaign already exists
            if (campaignList[campaignName]) {
                console.log('Campaign already exists in user data');
                console.log(userData);
                return;
            }
            
            campaignList[campaignName] = {
            campaignID: campaignName,
            characters: [],
            role: 'admin'
            };

            // rebuild userDataDynamo
            userDataDynamo.campaigns = campaignList;

            const userDatapayload = userDataDynamo;

            console.log('userDataDynamo:', userDataDynamo);

            const updatedUser = await createUser(userData.uniqueUser, userData.username, campaignList);

            if (updatedUser) {
                console.log('User updated:', updatedUser);
            }      

}


const createCampaign = async ( campaignName, userData ) => {

            // check to see if the user has 10 or more campaigns, reject if so
            const campaignList = userData.dynamoData.campaigns;
            const campaignCount = Object.keys(campaignList).length;

            console.log('Campaign count:', campaignCount);
            console.log('Campaign list:', campaignList);
            console.log('User data:', userData);

            if (campaignCount >= 10) {
                alert('User has reached the maximum number of campaigns');
                return 'Error: User has reached the maximum number of campaigns';
            }

            // const charsheetAPI = 'https://2gy03m48ej.execute-api.us-west-2.amazonaws.com/default/charsheet-access'
            const userTable = 'charsheet-campaigns'
            // const campaignName = 'js-test-campaign'
            const queryAPI = charsheetAPI + '?TableName=' + userTable + '&CampaignName=' + campaignName

            // Get current UTC time and format as YYYY-MM-DDTHH:MM:SSZ
            const now = new Date();
            const createdAt = now.toISOString().split('.')[0] + 'Z';

            const payload = {
                createdAt: createdAt,
                createdBy: userData.uniqueUser,
                campaignName: campaignName,
                campaignOwner: userData.uniqueUser,
                members: [ userData.uniqueUser ],
                discordURL: ''
            };
            
            let response
            try {
                response = await axios({
                    host: charsheetAPI,
                    method: 'PUT',
                    url: queryAPI,
                    headers: { 'content-type': 'text/plain' },
                    withCredentials: true,
                    data: { ...payload },   // this is the 'body' in AWS
                });
                
            } catch (error) {
                console.error('Error saving to campaign table:', error.response ? error.response.data : error.message);
                if (error.response.data === 'Campaign already exists') {
                    alert('Unable to create campaign:\n\nCampaign already exists') 
                } else {
                    alert('Unable to create campaign:\n\n' + error.response.data)
                }
                return `Error: ${error.response.data}`;
            }

            console.log('Successfully saved to campaign table:', response.data);
                
            addCampaignToUser(campaignName, userData);

            console.log('Successfully added campaign to user data:', response.data);

            Cookies.set('currentCampaign', campaignName, { expires: 3650 }); // Set cookie for 10 years

            return response.data;
        }        

export default createCampaign;